export default __webpack_public_path__ + "static/media/background-img.6b246723.png";